import { createSlice } from "@reduxjs/toolkit";

import * as Ether from "../shared/ether";

const initialState = {
  pending: [],
  mined: [],
  failed: [],
};

const savedStateName = "transactions";

const saveState = (state) => {
  const transactions = state.transactions;
  localStorage.setItem(savedStateName, JSON.stringify(transactions));
};

const preloadState = () => {
  const saved = localStorage.getItem(savedStateName);
  if (!saved) return initialState;

  const transactions = JSON.parse(saved);
  return {
    ...transactions,
    mined: initialState.mined,
    failed: initialState.failed,
  };
  // return JSON.parse(saved);
};

const transactionsSlice = createSlice({
  name: "transactions",
  initialState: preloadState(),
  reducers: {
    append: (state, action) => {
      state.pending.push({
        hash: action.payload.hash,
        metadata: action.payload.metadata,
      });
    },
    mined: (state, action) => {
      const pending = state.pending.find((tx) => tx.hash === action.payload.hash);
      state.pending = state.pending.filter((tx) => tx !== pending);

      state.mined.push(pending);
    },
    failed: (state, action) => {
      const pending = state.pending.find((tx) => tx.hash === action.payload.hash);
      state.pending = state.pending.filter((tx) => tx !== pending);

      state.failed.push({ ...pending, error: action.payload.error });
    },
    remove: (state, action) => {
      state.pending = state.pending.filter((tx) => tx.hash !== action.payload.hash);
      state.mined = state.mined.filter((tx) => tx.hash !== action.payload.hash);
      state.failed = state.failed.filter((tx) => tx.hash !== action.payload.hash);
    },
  },
});

const { append, mined, failed, remove } = transactionsSlice.actions;

const listen = (hash, metadata) => (dispatch, getState) => {
  const state = getState().transactions;

  const found = state.pending.find((tx) => tx.hash === hash);
  if (found != null) {
    throw Error("Already listenning for transaction");
  }

  dispatch(append({ hash, metadata }));
  saveState(getState());

  dispatch(_wait(hash));
};

const resume = () => (dispatch, getState) => {
  const pendings = getState().transactions.pending;
  pendings.forEach((tx) => {
    dispatch(_wait(tx.hash));
  });
};

const _wait = (hash) => (dispatch, getState) => {
  Ether.waitForTransaction(hash)
    .then((receipt) => {
      dispatch(mined({ hash: receipt.transactionHash }));

      saveState(getState());
    })
    .catch((error) => {
      dispatch(failed({ hash, error: { message: error.message, code: error.code } }));

      saveState(getState());
    });
};

export { listen, resume, remove };

export default transactionsSlice.reducer;
